import React from 'react';
import Switch from 'react-ios-switch';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import Swal from 'sweetalert2';
import globalEnum from '../../../enums/globalEnum';
import { useResponsive } from '../../../hooks/useResponsive';
import { setLoading } from '../../../services/reducers/homeSlice';
import { orderService } from './OrderService';

const { PaymentMethods, PaymentMethodNames } = globalEnum;

interface PaymentInfoSectionProps {
  form: any;
  updateNestedField: (parent: string, field: string, value: any) => void;
  id: string
}

const PaymentInfoSection: React.FC<PaymentInfoSectionProps> = ({
                                                                 form,
                                                                 updateNestedField,
  id
                                                               }) => {
  const { isMobile, getSelectStyles} = useResponsive();

  const paymentMethodOptions = Object.entries(PaymentMethods).map(([key, value]) => ({
    value: key,
    label: PaymentMethodNames[key]
  }));
  const dispatch = useDispatch();

  const sendPortal = async () => {
    dispatch(setLoading(true));

    const result = await orderService.sendPortal(id, form?.payment?.finalPrice, form?.payment?.method, form?.payment?.description, form?.payment?.refId, )

    dispatch(setLoading(false));

    if (result.success) {
      Swal.fire({
        title: 'موفق',
        text: 'لینک پرداخت با موفقیت ارسال شد',
        icon: 'success',
        confirmButtonText: 'متوجه شدم',
      });
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: result.error || 'خطا در ثبت سفارش',
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      });
    }
  };

  return (
    <div className="infoSection">
      <h1 className="dashBoardTitle">اطلاعات پرداخت</h1>
      <div className="orderInfoBox">
              <span className="factorHeader">
                <p>{form?.isWebsite ? 'اپلیکیشن' : 'اپراتور'}</p>
              </span>

        <label className="sideBarTitle" htmlFor="paymentMethod">نحوه پرداخت</label>
        <Select
          id="paymentMethod"
          name="paymentMethod"
          styles={getSelectStyles()}
          className="minWidth150"
          placeholder="انتخاب روش پرداخت"
          isSearchable={false}
          aria-label="نحوه پرداخت"
          value={{
            value: Object.keys(PaymentMethods).find(e => e === form?.payment?.method),
            label: PaymentMethodNames[Object.keys(PaymentMethods).find(e => e === form?.payment?.method) || '']
          }}
          options={paymentMethodOptions}
          onChange={(selected) => updateNestedField('payment', 'method', selected.value)}

        />

        <label className="sideBarTitle" htmlFor="walletBalance">کیف پول</label>
        <input
          id="walletBalance"
          disabled
          className="editProductInput disabled"
          value={form?.user?.walletBalance || 0}
          aria-label="کیف پول"
        />

        <div className="inputRow">
          <Switch
            checked={form?.payment?.shouldUseWallet || false}
            onChange={(checked) => updateNestedField('payment', 'shouldUseWallet', checked)}
            aria-label="استفاده از کیف پول"
          />
          <label className="sideBarTitle">استفاده از کیف پول</label>
        </div>

        <label className="sideBarTitle" htmlFor="paymentAmount">مبلغ</label>
        <input
          id="paymentAmount"
          className="editProductInput"
          value={form?.payment?.finalPrice || 0}
          onChange={(e) => updateNestedField('payment', 'finalPrice', e.target.value)}
          type="number"
          min="0"
          aria-label="مبلغ"
        />

        <label className="sideBarTitle" htmlFor="paymentAuthority">کد رهگیری</label>
        <input
          id="paymentAuthority"
          className="editProductInput"
          value={form?.payment?.refId || ''}
          onChange={(e) => updateNestedField('payment', 'refId', e.target.value)}
          placeholder="کد رهگیری پرداخت"
          aria-label="کد رهگیری"
        />

        <label className="sideBarTitle" htmlFor="paymentDescription">توضیحات</label>
        <textarea
          id="paymentDescription"
          className="editProductInput"
          value={form.payment?.description || ''}
          onChange={(e) => updateNestedField('payment', 'description', e.target.value)}
          placeholder="توضیحات اضافی"
          rows={isMobile ? 3 : 4}
          aria-label="توضیحات"
        />
        {(form?.payment?.method == PaymentMethods.zarinpal || form?.payment?.method == PaymentMethods.sep) &&
            <button className="addProductButton" onClick={sendPortal}>
                ارسال درگاه
            </button>
        }
      </div>
    </div>
  );
};

export default PaymentInfoSection;
